export default __webpack_public_path__ + "static/media/OpenSans-Light.1f45c30d.woff2";